import { createContext } from 'react';

export const initState = {
  selectedTemplates: [],
  onChangeSelectedTemplates: () => {}
};
export const TemplateListContext = createContext(initState);
